(function () {
  const EXCLUDED_TAGS = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'INPUT', 'CODE', 'PRE']);
  // Currency matching is one pass and preserves text around a complete amount.
  const CURRENCY_AMOUNT = /\bCHF[\s\u00a0]+(-?(?:\d{1,3}(?:['’ \u00a0\u202f]\d{3})+|\d+)(?:[.,]\d{1,2})?)(?![\d.,])|(?<![\w.,'’+-])(-?(?:\d{1,3}(?:['’ \u00a0\u202f]\d{3})+|\d+)(?:[.,]\d{1,2})?)[\s\u00a0]+CHF\b/g;

  function formatAmount(rawAmount) {
    let value = String(rawAmount || '').trim().replace(/\u00a0/g, ' ').replace(/[’]/g, "'");
    const negative = value.startsWith('-');

    value = value.replace(/^-/, '').trim();

    const lastDot = value.lastIndexOf('.');
    const lastComma = value.lastIndexOf(',');
    let decimalSeparator = '.';

    if (lastComma > lastDot && /^\d{1,2}$/.test(value.slice(lastComma + 1))) {
      decimalSeparator = ',';
    }

    const parts = value.split(decimalSeparator);
    const decimals = (parts.length > 1 ? parts.pop() : '00').replace(/\D/g, '').padEnd(2, '0').slice(0, 2);
    const whole = parts.join(decimalSeparator).replace(/\D/g, '') || '0';
    const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, "'");

    return `CHF ${negative ? '-' : ''}${grouped}.${decimals}`;
  }

  function normalizeText(text) {
    if (!text || !text.includes('CHF')) return text;

    return text.replace(CURRENCY_AMOUNT, function (_match, leadingAmount, trailingAmount) {
      return formatAmount(leadingAmount === undefined ? trailingAmount : leadingAmount);
    });
  }

  function normalizeTextNode(node) {
    const normalized = normalizeText(node.nodeValue);

    if (normalized !== node.nodeValue) {
      node.nodeValue = normalized;
    }
  }

  function shouldSkipElement(element) {
    return !element || EXCLUDED_TAGS.has(element.tagName);
  }

  function walk(root) {
    if (!root || shouldSkipElement(root)) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        if (!node.nodeValue || !node.nodeValue.includes('CHF')) {
          return NodeFilter.FILTER_REJECT;
        }

        if (shouldSkipElement(node.parentElement)) {
          return NodeFilter.FILTER_REJECT;
        }

        return NodeFilter.FILTER_ACCEPT;
      },
    });

    let node = walker.nextNode();
    while (node) {
      normalizeTextNode(node);
      node = walker.nextNode();
    }
  }

  function schedule(root) {
    window.requestAnimationFrame(function () {
      walk(root || document.body);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      schedule(document.body);
    });
  } else {
    schedule(document.body);
  }

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'characterData') {
        normalizeTextNode(mutation.target);
        return;
      }

      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === Node.TEXT_NODE) {
          normalizeTextNode(node);
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          schedule(node);
        }
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
  });
})();
